module.exports = __webpack_public_path__ + "img/QR-1799.2cc0e8ba.png";